<template>
	<section class="container mx-auto product-detail">
		<div calss="row item-compo">
			<div class="d-flex flex-wrap flex-row">
				<div class="col-12 col-md-6 order-2 bg-color1 left-box">
					<div class="col-12 mx-auto">
						<div class="text-center">
							<h4>{{title}}</h4>
							<span class="product_price secondary-point-color font-weight-nomal">{{price | addcomma}}円 </span>
							<div class="variation mt-5" v-show="isVariation">
								<select class="form-control" v-model="hin">
									<option v-for="v in variations" :key="v.index"  :value="v.variation_hinban">{{v.variation_name}}</option>
								</select>
							</div>
							<div class="d-block my-4">
								<div class="d-inline-block col-12 col-sm-9 product_addcart_form before_soldout">
									<div>
										<input type="button" value="カートへ入れる"	class="btn btn-color btn-block" id="product1_addcart" :disabled="isStocks" @click="cartIn(hin)"/>
									</div>
								</div>
								<div v-if="isStocks" class="mt-3">※この商品は現在ご購入いただけません</div>
							</div>
						</div>
					</div>
					<div v-if="isFjLogo" ref="fjLogo" class="fjLogo">
					</div>
				</div>
				<div class="text-center mx-auto col-10 col-md-6 order-1 right-box">
					<div v-if="isSingleImg" class="pSlide">
						<img :src="host+dList.ImgList[0].img_url">
					</div>
					<slick class="pSlide" ref="slick" :options="slickOptions" v-else>
						<div v-for="img in dList.ImgList" :key="img.index">
							<img :src="host+img.img_url">
						</div>
					</slick>
				</div>
			</div>
		</div>
		<div class="row item-detail mt-5">
			<div class="mx-auto col-12 bg-color2 text-justify pc_sentence sp_sentence">
				<p v-html="description1"></p>
			</div>
		</div>
		<div class="row item-detail" v-show="isContent">
			<div class="mx-auto col-12 bg-color2 text-justify pc_sentence sp_sentence">
				<p v-html="description2"></p>
			</div>
		</div>
		<div class="text-center px-5 pt-3 pb-5 row">
			<div class="col-2"></div>
			<div class="col-8">
				<input type="button" value="商品一覧へもどる" class="btn btn-color btn-block" @click="backList()"/>
			</div>
			<div class="col-2"></div>
		</div>
	</section>
</template>

<style>
/*	.pSlide{
		display: inline-block;
	}*/
	.item-detail img{
		max-width: 100%;
	}
	.pSlide div{
		align-items: center;
		display: flex !important;
		margin: 0 auto;
	}
	.pSlide img{
		max-height: 500px;
		max-width: 100%;
		height: auto;
		width: auto;
	}
	@media(max-width: 767px){
		.left-box{
			margin-top: 7vh;
		}
	}
	.left-box{
		align-items: center;
		display: flex;
		z-index: 1;
	}
	.right-box {
		z-index: 2;
	}
	.btn:disabled{
		background: #FFFFFF;
		color: #3e3c43;
		cursor: default;
	}
	.btn:disabled:hover{
		border-color: #3e3c43;
	}
	.fjLogo{
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		text-align: center;
	}
	.fjLogo img{
		height: 100%;
		width: auto;
	}
	@media(max-width: 767px){
		.fjLogo{
			position: relative;
			bottom: 0;
			left: 0;
			right: 0;
		}
	}
</style>

<script>
// import cSelect from './category.vue'
import slick from 'vue-slick'

export default{
	data(){
		return{
			slickOptions:{
				slidesToShow: 1,
				arrows: true,
				dots: true,
			},
			pagenum:'',
			hin:'',
			img_url:[],
			title:'',
			price:'',
			stocks:'',
			variations:[],
			description1:'',
			description2:'',
			isStocks:false,
			isContent:true,
			isSingleImg:false,
			isVariation:false,
			accessError:true,
			disRand:Math.floor(Math.random() * 100),
			errNum:Number,
			pathHin:this.$route.params.hin,
			pList:[],
			dList:[],
			pathQuery:this.$route.query,
			cart:process.env.VUE_APP_CARTURI+'/v2/shoppingcart.aspx?scode=K1ST&pcode=',
			host:process.env.VUE_APP_IAM,
			isFjLogo: true,
			notFjList: [
				'11770',
				'11775',
				'11786',
				'11787',
				'11788',
				'11789'
			]
		}
	},
	components:{
		// 'cSelect': cSelect,
		'slick': slick,
	},
	created(){
		scrollTo(0,0)
		this.chkHin()
		this.getJson()
		this.chkMedia()
	},
	mounted(){
		this.setFJL()
	},
	methods:{
		chkHin(){
			this.notFjList.forEach((v) => {
				if(this.pathHin == v){
					this.isFjLogo = false
				}
			})
		},
		setFJL(){
			if(this.isFjLogo){
				let fjID = document.createElement('script')
				fjID.innerHTML = 'var _fj_bnParam = {"merchant":"MA-352-93808837","bnType":"1","domain":"www.fromjapanlimited.com"}; try{_fj_bnDrow();}catch(e){console.log(e);};'
				this.$refs.fjLogo.appendChild(fjID)
			}
		},
		chkMedia(){
			if (window.innerWidth < 767) {
				return false
			}else{
				return true
			}
		},
		async getJson(){
			await this.$axios
			.get(this.$uri+'?type=product')
			.then((response) => {
				if(response.data.is_maintenance == true){
					window.location.href = "/maintenance/maintenance.html"
				}else{
					this.pList = response.data.product_list
					this.dList = this.pList.find((v) => v.Hin == this.pathHin)
					this.setData()
				}
			})
			.catch(() => {
				window.location.href = "/error/error.html"
			})
		},
		next() {
			this.$refs.slick.next();
		},
		prev() {
			this.$refs.slick.prev();
		},
		reInit() {
			this.$refs.slick.destroy();
			this.$nextTick(() => {
				this.$refs.slick.create();
			});
		},
		setData(){
			this.title = this.dList.Title
			this.price = this.dList.NetPrice
			this.hin = this.pathHin
			this.description1 = this.dList.ProductDescription1
			this.description2 = this.dList.ProductDescription2
			if(this.description2 == ""){
				this.isContent = false
			}
			this.variations = this.dList.variation_list
			if(this.variations.length <=1){
				this.stocks = this.dList.StockStatus
			}else{
				this.isVariation = true
				this.hin = this.variations[0].variation_hinban 
			}
			if(this.dList.ImgList.length == 1){
				this.isSingleImg = true
			}else{
				this.reInit()
			}
		},
		cartIn(item){
			window.location.href=this.cart+item;
		},
		backList(){
			this.$router.push('/products/'+this.$store.getters.get_pnum)
		},
	},
	filters: {
		addcomma: function (value) {
			if (!value) return ''
			return value.toString().replace(/(\d)(?=(\d{3})+$)/g , '$1,')
		},
	},
	watch: {
		hin: function() {
			if(this.variations.length==1){
				if(this.stocks == "SOLDOUT"){
						this.isStocks = true
					}else{
						this.isStocks = false
					}
			}else{
				for (var i=0; i<this.variations.length; i++) {
					if(this.variations[i].variation_hinban == this.hin){
						if(this.variations[i].variation_stockstatus == "SOLDOUT"){
							this.isStocks = true
						}else{
							this.isStocks = false
						}
					}
				}
			}
		}
	},
}
</script>